import React from 'react';
import './index.less';

interface Subject {
  code: string;
  name: string;
}

interface SchoolPeriodSubject {
  schoolPeriod: string;
  subjects: Subject[];
  matchAll: boolean;
}

 interface PermissionGroupItem {
  roleId: string;
  roleName: string;
  permissions: SchoolPeriodSubject[];
}

interface Props {
  data: PermissionGroupItem[];
  maxWidth?: number;
}

function getSchoolPeriodSubjectText(periodSubject: SchoolPeriodSubject): string {
  if (periodSubject.matchAll) {
    return `全部`;
  }

  const periodName = periodSubject.schoolPeriod;
  const subjectsText = periodSubject.subjects.map((item) => item.name).join('/');
  const extraTexts = [subjectsText].filter(Boolean);

  return [periodName, ...extraTexts].join('-');
}

function compareSchoolPeriod(a: string, b: string): number {
  return a.localeCompare(b, undefined, { numeric: true });
}

function mergePermissionsBySchoolPeriod(data: PermissionGroupItem[]): SchoolPeriodSubject[] {
  const periodSubjectMap = new Map<string, SchoolPeriodSubject>();

  data.forEach((roleItem) => {
    roleItem.permissions
      .filter((item) => !item.matchAll)
      .forEach((item) => {
        const existItem = periodSubjectMap.get(item.schoolPeriod);

        if (!existItem) {
          periodSubjectMap.set(item.schoolPeriod, { ...item, subjects: [...item.subjects] });
          return;
        }

        const subjectIds = new Set(existItem.subjects.map((subject) => subject.code));
        const newSubjects = item.subjects.filter((subject) => !subjectIds.has(subject.code));
        existItem.subjects = [...existItem.subjects, ...newSubjects];
      });
  });

  return Array.from(periodSubjectMap.values()).sort((a, b) =>
    compareSchoolPeriod(a.schoolPeriod, b.schoolPeriod),
  );
}

function renderRoleText(data: PermissionGroupItem[]): string {
  const schoolPeriodSubjectTexts = mergePermissionsBySchoolPeriod(data).map(getSchoolPeriodSubjectText);

  return schoolPeriodSubjectTexts.join('\n');
}

function RoleSchoolPeriodSubjectCard(props: Props) {
  const { data, maxWidth } = props;
  const roleText = renderRoleText(data || []);
  const roleItemTexts = roleText.split('\n');

  if (!roleText) {
    return <span style={{ color: '#d3d3d3' }}>——</span>;
  }

  return (
    <div className="roleSchoolPeriodSubjectCard" title={roleText}>
      {!maxWidth
        ? roleText
        : roleItemTexts.map((item) => (
            <div key={item} className="roleSchoolPeriodSubjectCard-item" style={{ maxWidth }}>
              {item}
            </div>
          ))}
    </div>
  );
}

export default RoleSchoolPeriodSubjectCard;
